
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.default || mod) {
      router.addRoute(route)
    }
    router.replace('')
  })
}

export function handleHotUpdate(_router) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
  }
}
import { default as indexIXbw6OoBt0Meta } from "/codebuild/output/src1209866614/src/pages/index.vue?macro=true";
import { default as aboutQOvJmnmFUzMeta } from "/codebuild/output/src1209866614/src/pages/about.vue?macro=true";
import { default as data4Xto5J4ydTMeta } from "/codebuild/output/src1209866614/src/pages/account-settings/data.vue?macro=true";
import { default as manage_45subscriptionCu70OHK6i7Meta } from "/codebuild/output/src1209866614/src/pages/account-settings/manage-subscription.vue?macro=true";
import { default as positioningzrENvbnxSlMeta } from "/codebuild/output/src1209866614/src/pages/account-settings/positioning.vue?macro=true";
import { default as privacyjiciPDaPc6Meta } from "/codebuild/output/src1209866614/src/pages/account-settings/privacy.vue?macro=true";
import { default as remove_45accountyUO8De970yMeta } from "/codebuild/output/src1209866614/src/pages/account-settings/remove-account.vue?macro=true";
import { default as statuezRrzcjCAYoMeta } from "/codebuild/output/src1209866614/src/pages/account-settings/statue.vue?macro=true";
import { default as support5TlHzoLvNkMeta } from "/codebuild/output/src1209866614/src/pages/account-settings/support.vue?macro=true";
import { default as account_45settingstF1BzXLlbdMeta } from "/codebuild/output/src1209866614/src/pages/account-settings.vue?macro=true";
import { default as activate_45account2h7FQySoSLMeta } from "/codebuild/output/src1209866614/src/pages/activate-account.vue?macro=true";
import { default as companykTzZYJGWi8Meta } from "/codebuild/output/src1209866614/src/pages/admin/company.vue?macro=true";
import { default as consentsagEnvZNMbPMeta } from "/codebuild/output/src1209866614/src/pages/admin/consents.vue?macro=true";
import { default as leads3rvQ5AXOGlMeta } from "/codebuild/output/src1209866614/src/pages/admin/leads.vue?macro=true";
import { default as paymentsrXeObQU1YpMeta } from "/codebuild/output/src1209866614/src/pages/admin/payments.vue?macro=true";
import { default as premiumQHQ595LICfMeta } from "/codebuild/output/src1209866614/src/pages/admin/premium.vue?macro=true";
import { default as profilesgw8e5uBobCMeta } from "/codebuild/output/src1209866614/src/pages/admin/profiles.vue?macro=true";
import { default as usersP42Jwkr2zyMeta } from "/codebuild/output/src1209866614/src/pages/admin/users.vue?macro=true";
import { default as change_45passworduhgFPgLphZMeta } from "/codebuild/output/src1209866614/src/pages/change-password.vue?macro=true";
import { default as _91id_93oZKdyp5u2FMeta } from "/codebuild/output/src1209866614/src/pages/chat/[id].vue?macro=true";
import { default as aiKbUrAoHaW7Meta } from "/codebuild/output/src1209866614/src/pages/chat/ai.vue?macro=true";
import { default as index9RJFfziGwzMeta } from "/codebuild/output/src1209866614/src/pages/chat/index.vue?macro=true";
import { default as chatHnYn8EB9NpMeta } from "/codebuild/output/src1209866614/src/pages/chat.vue?macro=true";
import { default as _91id_93c5niy6oZMZMeta } from "/codebuild/output/src1209866614/src/pages/client/profile/[id].vue?macro=true";
import { default as indexUcRmjVpw4jMeta } from "/codebuild/output/src1209866614/src/pages/client/profile/index.vue?macro=true";
import { default as _91id_93qg2jW9qxzNMeta } from "/codebuild/output/src1209866614/src/pages/contacts/[id].vue?macro=true";
import { default as index134c8jnAMDMeta } from "/codebuild/output/src1209866614/src/pages/contacts/index.vue?macro=true";
import { default as contactsPQuUfQJOw0Meta } from "/codebuild/output/src1209866614/src/pages/contacts.vue?macro=true";
import { default as _91userId_93Hdl13QplrlMeta } from "/codebuild/output/src1209866614/src/pages/delete-mailing/[email]/[userId].vue?macro=true";
import { default as indexs4qd1PIGQdMeta } from "/codebuild/output/src1209866614/src/pages/login/index.vue?macro=true";
import { default as register_45successS2auo66dQvMeta } from "/codebuild/output/src1209866614/src/pages/login/register-success.vue?macro=true";
import { default as login4UYCfsnt5sMeta } from "/codebuild/output/src1209866614/src/pages/login.vue?macro=true";
import { default as logoutwAeZjxU8HgMeta } from "/codebuild/output/src1209866614/src/pages/logout.vue?macro=true";
import { default as consentsZtRREaSJEgMeta } from "/codebuild/output/src1209866614/src/pages/manager/consents.vue?macro=true";
import { default as integrationsWSzuobXi06Meta } from "/codebuild/output/src1209866614/src/pages/manager/integrations.vue?macro=true";
import { default as leadsaEQvSXuEjvMeta } from "/codebuild/output/src1209866614/src/pages/manager/leads.vue?macro=true";
import { default as paymentsgvf9sSfwMzMeta } from "/codebuild/output/src1209866614/src/pages/manager/payments.vue?macro=true";
import { default as profileVumppeQoKRMeta } from "/codebuild/output/src1209866614/src/pages/manager/profile.vue?macro=true";
import { default as team4V0AEykjYDMeta } from "/codebuild/output/src1209866614/src/pages/manager/team.vue?macro=true";
import { default as indexb4oeRd7g5BMeta } from "/codebuild/output/src1209866614/src/pages/marketplace/index.vue?macro=true";
import { default as _91catId_93_46clientKcmO0NHVEAMeta } from "/codebuild/output/src1209866614/src/pages/marketplace/search/[catId].client.vue?macro=true";

let _createClientPage
async function createClientPage(loader) {
  _createClientPage ||= await import("/codebuild/output/src1209866614/src/node_modules/nuxt/dist/components/runtime/client-component.js").then(r => r.createClientPage)
  return _createClientPage(loader);
}
import { default as marketplaceu1gmqkaamsMeta } from "/codebuild/output/src1209866614/src/pages/marketplace.vue?macro=true";
import { default as subscribeiYLomEmWKNMeta } from "/codebuild/output/src1209866614/src/pages/newsletter/subscribe.vue?macro=true";
import { default as find_46clientZ2qiLMAlkHMeta } from "/codebuild/output/src1209866614/src/pages/orders/find.client.vue?macro=true";
import { default as my_46clientdwJd4KylcKMeta } from "/codebuild/output/src1209866614/src/pages/orders/my.client.vue?macro=true";
import { default as privacyLxfpVHztBGMeta } from "/codebuild/output/src1209866614/src/pages/privacy.vue?macro=true";
import { default as indexseh5wkgfsrMeta } from "/codebuild/output/src1209866614/src/pages/recover/index.vue?macro=true";
import { default as successWTgd93zjl4Meta } from "/codebuild/output/src1209866614/src/pages/register/success.vue?macro=true";
import { default as _91id_93qMNox4WniqMeta } from "/codebuild/output/src1209866614/src/pages/sales/profile/[id].vue?macro=true";
import { default as index3CRzR2zdDIMeta } from "/codebuild/output/src1209866614/src/pages/sales/profile/index.vue?macro=true";
import { default as statuewGDvKc1uJWMeta } from "/codebuild/output/src1209866614/src/pages/statue.vue?macro=true";
import { default as success5K42crAypyMeta } from "/codebuild/output/src1209866614/src/pages/subscription/success.vue?macro=true";
import { default as component_45stubcsV4LbsrsgMeta } from "/codebuild/output/src1209866614/src/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubcsV4Lbsrsg } from "/codebuild/output/src1209866614/src/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "index",
    path: "/",
    meta: indexIXbw6OoBt0Meta || {},
    component: () => import("/codebuild/output/src1209866614/src/pages/index.vue")
  },
  {
    name: "about___en",
    path: "/en/about",
    meta: aboutQOvJmnmFUzMeta || {},
    component: () => import("/codebuild/output/src1209866614/src/pages/about.vue")
  },
  {
    name: "about___pl",
    path: "/pl/about",
    meta: aboutQOvJmnmFUzMeta || {},
    component: () => import("/codebuild/output/src1209866614/src/pages/about.vue")
  },
  {
    name: "account-settings___en",
    path: "/en/account-settings",
    meta: account_45settingstF1BzXLlbdMeta || {},
    component: () => import("/codebuild/output/src1209866614/src/pages/account-settings.vue"),
    children: [
  {
    name: "account-settings-data___en",
    path: "data",
    component: () => import("/codebuild/output/src1209866614/src/pages/account-settings/data.vue")
  },
  {
    name: "account-settings-manage-subscription___en",
    path: "manage-subscription",
    component: () => import("/codebuild/output/src1209866614/src/pages/account-settings/manage-subscription.vue")
  },
  {
    name: "account-settings-positioning___en",
    path: "positioning",
    component: () => import("/codebuild/output/src1209866614/src/pages/account-settings/positioning.vue")
  },
  {
    name: "account-settings-privacy___en",
    path: "privacy",
    component: () => import("/codebuild/output/src1209866614/src/pages/account-settings/privacy.vue")
  },
  {
    name: "account-settings-remove-account___en",
    path: "remove-account",
    component: () => import("/codebuild/output/src1209866614/src/pages/account-settings/remove-account.vue")
  },
  {
    name: "account-settings-statue___en",
    path: "statue",
    component: () => import("/codebuild/output/src1209866614/src/pages/account-settings/statue.vue")
  },
  {
    name: "account-settings-support___en",
    path: "support",
    component: () => import("/codebuild/output/src1209866614/src/pages/account-settings/support.vue")
  }
]
  },
  {
    name: "account-settings___pl",
    path: "/pl/account-settings",
    meta: account_45settingstF1BzXLlbdMeta || {},
    component: () => import("/codebuild/output/src1209866614/src/pages/account-settings.vue"),
    children: [
  {
    name: "account-settings-data___pl",
    path: "data",
    component: () => import("/codebuild/output/src1209866614/src/pages/account-settings/data.vue")
  },
  {
    name: "account-settings-manage-subscription___pl",
    path: "manage-subscription",
    component: () => import("/codebuild/output/src1209866614/src/pages/account-settings/manage-subscription.vue")
  },
  {
    name: "account-settings-positioning___pl",
    path: "positioning",
    component: () => import("/codebuild/output/src1209866614/src/pages/account-settings/positioning.vue")
  },
  {
    name: "account-settings-privacy___pl",
    path: "privacy",
    component: () => import("/codebuild/output/src1209866614/src/pages/account-settings/privacy.vue")
  },
  {
    name: "account-settings-remove-account___pl",
    path: "remove-account",
    component: () => import("/codebuild/output/src1209866614/src/pages/account-settings/remove-account.vue")
  },
  {
    name: "account-settings-statue___pl",
    path: "statue",
    component: () => import("/codebuild/output/src1209866614/src/pages/account-settings/statue.vue")
  },
  {
    name: "account-settings-support___pl",
    path: "support",
    component: () => import("/codebuild/output/src1209866614/src/pages/account-settings/support.vue")
  }
]
  },
  {
    name: "activate-account___en",
    path: "/en/activate-account",
    meta: activate_45account2h7FQySoSLMeta || {},
    component: () => import("/codebuild/output/src1209866614/src/pages/activate-account.vue")
  },
  {
    name: "activate-account___pl",
    path: "/pl/activate-account",
    meta: activate_45account2h7FQySoSLMeta || {},
    component: () => import("/codebuild/output/src1209866614/src/pages/activate-account.vue")
  },
  {
    name: "admin-company___en",
    path: "/en/admin/company",
    meta: companykTzZYJGWi8Meta || {},
    component: () => import("/codebuild/output/src1209866614/src/pages/admin/company.vue")
  },
  {
    name: "admin-company___pl",
    path: "/pl/admin/company",
    meta: companykTzZYJGWi8Meta || {},
    component: () => import("/codebuild/output/src1209866614/src/pages/admin/company.vue")
  },
  {
    name: "admin-consents___en",
    path: "/en/admin/consents",
    meta: consentsagEnvZNMbPMeta || {},
    component: () => import("/codebuild/output/src1209866614/src/pages/admin/consents.vue")
  },
  {
    name: "admin-consents___pl",
    path: "/pl/admin/consents",
    meta: consentsagEnvZNMbPMeta || {},
    component: () => import("/codebuild/output/src1209866614/src/pages/admin/consents.vue")
  },
  {
    name: "admin-leads___en",
    path: "/en/admin/leads",
    meta: leads3rvQ5AXOGlMeta || {},
    component: () => import("/codebuild/output/src1209866614/src/pages/admin/leads.vue")
  },
  {
    name: "admin-leads___pl",
    path: "/pl/admin/leads",
    meta: leads3rvQ5AXOGlMeta || {},
    component: () => import("/codebuild/output/src1209866614/src/pages/admin/leads.vue")
  },
  {
    name: "admin-payments___en",
    path: "/en/admin/payments",
    meta: paymentsrXeObQU1YpMeta || {},
    component: () => import("/codebuild/output/src1209866614/src/pages/admin/payments.vue")
  },
  {
    name: "admin-payments___pl",
    path: "/pl/admin/payments",
    meta: paymentsrXeObQU1YpMeta || {},
    component: () => import("/codebuild/output/src1209866614/src/pages/admin/payments.vue")
  },
  {
    name: "admin-premium___en",
    path: "/en/admin/premium",
    meta: premiumQHQ595LICfMeta || {},
    component: () => import("/codebuild/output/src1209866614/src/pages/admin/premium.vue")
  },
  {
    name: "admin-premium___pl",
    path: "/pl/admin/premium",
    meta: premiumQHQ595LICfMeta || {},
    component: () => import("/codebuild/output/src1209866614/src/pages/admin/premium.vue")
  },
  {
    name: "admin-profiles___en",
    path: "/en/admin/profiles",
    meta: profilesgw8e5uBobCMeta || {},
    component: () => import("/codebuild/output/src1209866614/src/pages/admin/profiles.vue")
  },
  {
    name: "admin-profiles___pl",
    path: "/pl/admin/profiles",
    meta: profilesgw8e5uBobCMeta || {},
    component: () => import("/codebuild/output/src1209866614/src/pages/admin/profiles.vue")
  },
  {
    name: "admin-users___en",
    path: "/en/admin/users",
    meta: usersP42Jwkr2zyMeta || {},
    component: () => import("/codebuild/output/src1209866614/src/pages/admin/users.vue")
  },
  {
    name: "admin-users___pl",
    path: "/pl/admin/users",
    meta: usersP42Jwkr2zyMeta || {},
    component: () => import("/codebuild/output/src1209866614/src/pages/admin/users.vue")
  },
  {
    name: "change-password___en",
    path: "/en/change-password",
    meta: change_45passworduhgFPgLphZMeta || {},
    component: () => import("/codebuild/output/src1209866614/src/pages/change-password.vue")
  },
  {
    name: "change-password___pl",
    path: "/pl/change-password",
    meta: change_45passworduhgFPgLphZMeta || {},
    component: () => import("/codebuild/output/src1209866614/src/pages/change-password.vue")
  },
  {
    name: chatHnYn8EB9NpMeta?.name,
    path: "/en/chat",
    meta: chatHnYn8EB9NpMeta || {},
    component: () => import("/codebuild/output/src1209866614/src/pages/chat.vue"),
    children: [
  {
    name: "chat-id___en",
    path: ":id()",
    meta: _91id_93oZKdyp5u2FMeta || {},
    component: () => import("/codebuild/output/src1209866614/src/pages/chat/[id].vue")
  },
  {
    name: "chat-ai___en",
    path: "ai",
    meta: aiKbUrAoHaW7Meta || {},
    component: () => import("/codebuild/output/src1209866614/src/pages/chat/ai.vue")
  },
  {
    name: "chat___en",
    path: "",
    meta: index9RJFfziGwzMeta || {},
    component: () => import("/codebuild/output/src1209866614/src/pages/chat/index.vue")
  }
]
  },
  {
    name: chatHnYn8EB9NpMeta?.name,
    path: "/pl/chat",
    meta: chatHnYn8EB9NpMeta || {},
    component: () => import("/codebuild/output/src1209866614/src/pages/chat.vue"),
    children: [
  {
    name: "chat-id___pl",
    path: ":id()",
    meta: _91id_93oZKdyp5u2FMeta || {},
    component: () => import("/codebuild/output/src1209866614/src/pages/chat/[id].vue")
  },
  {
    name: "chat-ai___pl",
    path: "ai",
    meta: aiKbUrAoHaW7Meta || {},
    component: () => import("/codebuild/output/src1209866614/src/pages/chat/ai.vue")
  },
  {
    name: "chat___pl",
    path: "",
    meta: index9RJFfziGwzMeta || {},
    component: () => import("/codebuild/output/src1209866614/src/pages/chat/index.vue")
  }
]
  },
  {
    name: "client-profile-id___en",
    path: "/en/client/profile/:id()",
    meta: _91id_93c5niy6oZMZMeta || {},
    component: () => import("/codebuild/output/src1209866614/src/pages/client/profile/[id].vue")
  },
  {
    name: "client-profile-id___pl",
    path: "/pl/client/profile/:id()",
    meta: _91id_93c5niy6oZMZMeta || {},
    component: () => import("/codebuild/output/src1209866614/src/pages/client/profile/[id].vue")
  },
  {
    name: "client-profile___en",
    path: "/en/client/profile",
    meta: indexUcRmjVpw4jMeta || {},
    component: () => import("/codebuild/output/src1209866614/src/pages/client/profile/index.vue")
  },
  {
    name: "client-profile___pl",
    path: "/pl/client/profile",
    meta: indexUcRmjVpw4jMeta || {},
    component: () => import("/codebuild/output/src1209866614/src/pages/client/profile/index.vue")
  },
  {
    name: contactsPQuUfQJOw0Meta?.name,
    path: "/en/contacts",
    meta: contactsPQuUfQJOw0Meta || {},
    component: () => import("/codebuild/output/src1209866614/src/pages/contacts.vue"),
    children: [
  {
    name: "contacts-id___en",
    path: ":id()",
    meta: _91id_93qg2jW9qxzNMeta || {},
    component: () => import("/codebuild/output/src1209866614/src/pages/contacts/[id].vue")
  },
  {
    name: "contacts___en",
    path: "",
    meta: index134c8jnAMDMeta || {},
    component: () => import("/codebuild/output/src1209866614/src/pages/contacts/index.vue")
  }
]
  },
  {
    name: contactsPQuUfQJOw0Meta?.name,
    path: "/pl/contacts",
    meta: contactsPQuUfQJOw0Meta || {},
    component: () => import("/codebuild/output/src1209866614/src/pages/contacts.vue"),
    children: [
  {
    name: "contacts-id___pl",
    path: ":id()",
    meta: _91id_93qg2jW9qxzNMeta || {},
    component: () => import("/codebuild/output/src1209866614/src/pages/contacts/[id].vue")
  },
  {
    name: "contacts___pl",
    path: "",
    meta: index134c8jnAMDMeta || {},
    component: () => import("/codebuild/output/src1209866614/src/pages/contacts/index.vue")
  }
]
  },
  {
    name: "delete-mailing-email-userId___en",
    path: "/en/delete-mailing/:email()/:userId()",
    meta: _91userId_93Hdl13QplrlMeta || {},
    component: () => import("/codebuild/output/src1209866614/src/pages/delete-mailing/[email]/[userId].vue")
  },
  {
    name: "delete-mailing-email-userId___pl",
    path: "/pl/delete-mailing/:email()/:userId()",
    meta: _91userId_93Hdl13QplrlMeta || {},
    component: () => import("/codebuild/output/src1209866614/src/pages/delete-mailing/[email]/[userId].vue")
  },
  {
    name: "index___en",
    path: "/en",
    meta: indexIXbw6OoBt0Meta || {},
    component: () => import("/codebuild/output/src1209866614/src/pages/index.vue")
  },
  {
    name: "index___pl",
    path: "/pl",
    meta: indexIXbw6OoBt0Meta || {},
    component: () => import("/codebuild/output/src1209866614/src/pages/index.vue")
  },
  {
    name: login4UYCfsnt5sMeta?.name,
    path: "/en/login",
    component: () => import("/codebuild/output/src1209866614/src/pages/login.vue"),
    children: [
  {
    name: "login___en",
    path: "",
    meta: indexs4qd1PIGQdMeta || {},
    component: () => import("/codebuild/output/src1209866614/src/pages/login/index.vue")
  },
  {
    name: "login-register-success___en",
    path: "register-success",
    meta: register_45successS2auo66dQvMeta || {},
    component: () => import("/codebuild/output/src1209866614/src/pages/login/register-success.vue")
  }
]
  },
  {
    name: login4UYCfsnt5sMeta?.name,
    path: "/pl/login",
    component: () => import("/codebuild/output/src1209866614/src/pages/login.vue"),
    children: [
  {
    name: "login___pl",
    path: "",
    meta: indexs4qd1PIGQdMeta || {},
    component: () => import("/codebuild/output/src1209866614/src/pages/login/index.vue")
  },
  {
    name: "login-register-success___pl",
    path: "register-success",
    meta: register_45successS2auo66dQvMeta || {},
    component: () => import("/codebuild/output/src1209866614/src/pages/login/register-success.vue")
  }
]
  },
  {
    name: "logout___en",
    path: "/en/logout",
    meta: logoutwAeZjxU8HgMeta || {},
    component: () => import("/codebuild/output/src1209866614/src/pages/logout.vue")
  },
  {
    name: "logout___pl",
    path: "/pl/logout",
    meta: logoutwAeZjxU8HgMeta || {},
    component: () => import("/codebuild/output/src1209866614/src/pages/logout.vue")
  },
  {
    name: "manager-consents___en",
    path: "/en/manager/consents",
    meta: consentsZtRREaSJEgMeta || {},
    component: () => import("/codebuild/output/src1209866614/src/pages/manager/consents.vue")
  },
  {
    name: "manager-consents___pl",
    path: "/pl/manager/consents",
    meta: consentsZtRREaSJEgMeta || {},
    component: () => import("/codebuild/output/src1209866614/src/pages/manager/consents.vue")
  },
  {
    name: "manager-integrations___en",
    path: "/en/manager/integrations",
    meta: integrationsWSzuobXi06Meta || {},
    component: () => import("/codebuild/output/src1209866614/src/pages/manager/integrations.vue")
  },
  {
    name: "manager-integrations___pl",
    path: "/pl/manager/integrations",
    meta: integrationsWSzuobXi06Meta || {},
    component: () => import("/codebuild/output/src1209866614/src/pages/manager/integrations.vue")
  },
  {
    name: "manager-leads___en",
    path: "/en/manager/leads",
    meta: leadsaEQvSXuEjvMeta || {},
    component: () => import("/codebuild/output/src1209866614/src/pages/manager/leads.vue")
  },
  {
    name: "manager-leads___pl",
    path: "/pl/manager/leads",
    meta: leadsaEQvSXuEjvMeta || {},
    component: () => import("/codebuild/output/src1209866614/src/pages/manager/leads.vue")
  },
  {
    name: "manager-payments___en",
    path: "/en/manager/payments",
    meta: paymentsgvf9sSfwMzMeta || {},
    component: () => import("/codebuild/output/src1209866614/src/pages/manager/payments.vue")
  },
  {
    name: "manager-payments___pl",
    path: "/pl/manager/payments",
    meta: paymentsgvf9sSfwMzMeta || {},
    component: () => import("/codebuild/output/src1209866614/src/pages/manager/payments.vue")
  },
  {
    name: "manager-profile___en",
    path: "/en/manager/profile",
    meta: profileVumppeQoKRMeta || {},
    component: () => import("/codebuild/output/src1209866614/src/pages/manager/profile.vue")
  },
  {
    name: "manager-profile___pl",
    path: "/pl/manager/profile",
    meta: profileVumppeQoKRMeta || {},
    component: () => import("/codebuild/output/src1209866614/src/pages/manager/profile.vue")
  },
  {
    name: "manager-team___en",
    path: "/en/manager/team",
    meta: team4V0AEykjYDMeta || {},
    component: () => import("/codebuild/output/src1209866614/src/pages/manager/team.vue")
  },
  {
    name: "manager-team___pl",
    path: "/pl/manager/team",
    meta: team4V0AEykjYDMeta || {},
    component: () => import("/codebuild/output/src1209866614/src/pages/manager/team.vue")
  },
  {
    name: marketplaceu1gmqkaamsMeta?.name,
    path: "/en/marketplace",
    meta: marketplaceu1gmqkaamsMeta || {},
    component: () => import("/codebuild/output/src1209866614/src/pages/marketplace.vue"),
    children: [
  {
    name: "marketplace___en",
    path: "",
    component: () => import("/codebuild/output/src1209866614/src/pages/marketplace/index.vue")
  },
  {
    name: "marketplace-search-catId___en",
    path: "search/:catId()",
    meta: _91catId_93_46clientKcmO0NHVEAMeta || {},
    component: () => createClientPage(() => import("/codebuild/output/src1209866614/src/pages/marketplace/search/[catId].client.vue"))
  }
]
  },
  {
    name: marketplaceu1gmqkaamsMeta?.name,
    path: "/pl/marketplace",
    meta: marketplaceu1gmqkaamsMeta || {},
    component: () => import("/codebuild/output/src1209866614/src/pages/marketplace.vue"),
    children: [
  {
    name: "marketplace___pl",
    path: "",
    component: () => import("/codebuild/output/src1209866614/src/pages/marketplace/index.vue")
  },
  {
    name: "marketplace-search-catId___pl",
    path: "search/:catId()",
    meta: _91catId_93_46clientKcmO0NHVEAMeta || {},
    component: () => createClientPage(() => import("/codebuild/output/src1209866614/src/pages/marketplace/search/[catId].client.vue"))
  }
]
  },
  {
    name: "newsletter-subscribe___en",
    path: "/en/newsletter/subscribe",
    meta: subscribeiYLomEmWKNMeta || {},
    component: () => import("/codebuild/output/src1209866614/src/pages/newsletter/subscribe.vue")
  },
  {
    name: "newsletter-subscribe___pl",
    path: "/pl/newsletter/subscribe",
    meta: subscribeiYLomEmWKNMeta || {},
    component: () => import("/codebuild/output/src1209866614/src/pages/newsletter/subscribe.vue")
  },
  {
    name: "orders-find___en",
    path: "/en/orders/find",
    meta: find_46clientZ2qiLMAlkHMeta || {},
    component: () => createClientPage(() => import("/codebuild/output/src1209866614/src/pages/orders/find.client.vue"))
  },
  {
    name: "orders-find___pl",
    path: "/pl/orders/find",
    meta: find_46clientZ2qiLMAlkHMeta || {},
    component: () => createClientPage(() => import("/codebuild/output/src1209866614/src/pages/orders/find.client.vue"))
  },
  {
    name: "orders-my___en",
    path: "/en/orders/my",
    meta: my_46clientdwJd4KylcKMeta || {},
    component: () => createClientPage(() => import("/codebuild/output/src1209866614/src/pages/orders/my.client.vue"))
  },
  {
    name: "orders-my___pl",
    path: "/pl/orders/my",
    meta: my_46clientdwJd4KylcKMeta || {},
    component: () => createClientPage(() => import("/codebuild/output/src1209866614/src/pages/orders/my.client.vue"))
  },
  {
    name: "privacy___en",
    path: "/en/privacy",
    meta: privacyLxfpVHztBGMeta || {},
    component: () => import("/codebuild/output/src1209866614/src/pages/privacy.vue")
  },
  {
    name: "privacy___pl",
    path: "/pl/privacy",
    meta: privacyLxfpVHztBGMeta || {},
    component: () => import("/codebuild/output/src1209866614/src/pages/privacy.vue")
  },
  {
    name: "recover___en",
    path: "/en/recover",
    meta: indexseh5wkgfsrMeta || {},
    component: () => import("/codebuild/output/src1209866614/src/pages/recover/index.vue")
  },
  {
    name: "recover___pl",
    path: "/pl/recover",
    meta: indexseh5wkgfsrMeta || {},
    component: () => import("/codebuild/output/src1209866614/src/pages/recover/index.vue")
  },
  {
    name: "register-success___en",
    path: "/en/register/success",
    component: () => import("/codebuild/output/src1209866614/src/pages/register/success.vue")
  },
  {
    name: "register-success___pl",
    path: "/pl/register/success",
    component: () => import("/codebuild/output/src1209866614/src/pages/register/success.vue")
  },
  {
    name: "sales-profile-id___en",
    path: "/en/sales/profile/:id()",
    meta: _91id_93qMNox4WniqMeta || {},
    component: () => import("/codebuild/output/src1209866614/src/pages/sales/profile/[id].vue")
  },
  {
    name: "sales-profile-id___pl",
    path: "/pl/sales/profile/:id()",
    meta: _91id_93qMNox4WniqMeta || {},
    component: () => import("/codebuild/output/src1209866614/src/pages/sales/profile/[id].vue")
  },
  {
    name: "sales-profile___en",
    path: "/en/sales/profile",
    meta: index3CRzR2zdDIMeta || {},
    component: () => import("/codebuild/output/src1209866614/src/pages/sales/profile/index.vue")
  },
  {
    name: "sales-profile___pl",
    path: "/pl/sales/profile",
    meta: index3CRzR2zdDIMeta || {},
    component: () => import("/codebuild/output/src1209866614/src/pages/sales/profile/index.vue")
  },
  {
    name: "statue___en",
    path: "/en/statue",
    meta: statuewGDvKc1uJWMeta || {},
    component: () => import("/codebuild/output/src1209866614/src/pages/statue.vue")
  },
  {
    name: "statue___pl",
    path: "/pl/statue",
    meta: statuewGDvKc1uJWMeta || {},
    component: () => import("/codebuild/output/src1209866614/src/pages/statue.vue")
  },
  {
    name: "subscription-success___en",
    path: "/en/subscription/success",
    meta: success5K42crAypyMeta || {},
    component: () => import("/codebuild/output/src1209866614/src/pages/subscription/success.vue")
  },
  {
    name: "subscription-success___pl",
    path: "/pl/subscription/success",
    meta: success5K42crAypyMeta || {},
    component: () => import("/codebuild/output/src1209866614/src/pages/subscription/success.vue")
  },
  {
    name: component_45stubcsV4LbsrsgMeta?.name,
    path: "/old-page",
    component: component_45stubcsV4Lbsrsg
  }
]